import React from 'react';

export default React.createClass({
	render() {
		return (
			<div hidden={!this.props.isLoading} className='LoadingIndicator'></div>
		);
	},
});